<script>
    export let project_data;   
</script> 

<a href="/images/templates/modal/{project_data.id}.jpg" data-gallery="{project_data.id}" data-type="image" class="p-relative glightbox portfolio_link">
    <slot></slot>
</a> 

<style>
    .portfolio_link{
        display: block;
        height: 0;
        overflow: hidden;
        padding-bottom: 56.25%;
        z-index: 10;
    }
</style>